(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('mainWorkspace', mainWorkspace);

    mainWorkspace.$inject = ['$log', '_', 'upload3DModelSettings'];

    function mainWorkspace($log, _, settings) {

        var workspace = {
            product: null,
            materials: null,
            fileToShowDirectly: null,
            issue: null,

            options: {
                units: settings.units,
                currencyId: settings.currencyId,
                productTemplateId: settings.productTemplateId,
                viewer: {
                    numberOfFrames: 17,
                    groundPlane: true,
                    clipping: false,
                    autoRotate: false,
                    cameraPosition: null
                }
            }
        };

        return workspace;
    }
}());